import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';

class OpenPOReportStore extends EventEmitter {
    updateFavPageResponse = { updateType: 0, responseStr: "" };
    /*[04/29/22,PC_WW-393_13], Priyanka D */
    ShipToresponse = "";
    handleOpenPOReportStore = (action) => {
        switch (action.action.type) {
            case SDIConstants.methodNames.GetOpenPODetails: {
                this.GetOpenPOResponse = action.action.response;
                this.emit('GetOpenPOResponse');
                break;
            }  
            case SDIConstants.methodNames.GetVendorInfo: {
                this.GetVendorInfoResposne = action.action.response;
                this.emit('GetVendorInfoResposne');
                break;
            }
            case SDIConstants.methodNames.GetExportDetails: {
                this.Excel = action.action.response;
                ;
                this.emit('Export');
                break;
            }
            case "ORDERSTS_InsertFavPage": {
                this.updateFavPageResponse.updateType = 1;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "ORDERSTS_DeleteFavPage": {
                this.updateFavPageResponse.updateType = 2;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "ORDERSTS_CurrentFavPage": {
                this.currentFavPageResponse = action.action.response;
                this.emit('favpage');
                break;
            }
            /*[04/29/22,PC_WW-393_13], Priyanka D */
            case "ShipToresponse": {
                this.ShipToresponse = action.action.response;
                this.emit('ShipToresponse');
                break;
            } 
        }
    }
}
const objOpenPOReportStore = new OpenPOReportStore;
Dispatcher.register(objOpenPOReportStore.handleOpenPOReportStore.bind(objOpenPOReportStore));
export default objOpenPOReportStore;